export default (state = {
    testSuiteList: [],
    allTestSuite: [],
    totalItems: 0,
    currentPage: 1,
    pageCount: 1,
    pageSize: localStorage.getItem("testSuitePageSize") ? Number(localStorage.getItem("testSuitePageSize")) : 30
}, action) => {
    switch (action.type) {
        case "SET_TEST_SUITE":
            return {
                ...state,
                testSuiteList: action.payload,
                // currentPage: action.currentPage,
                sortBy: action.sortBy,
                sortOrder: action.sortOrder,
                totalItems: action.totalItems,
                pageCount: action.pageCount || 1,
            }
        case "SET_ALL_TEST_SUITE":
            return {
                ...state,
                allQuestionCategory: action.payload
            }
        case "CHANGE_PAGE_SIZE_TEST_SUITE":
            return {
                ...state,
                pageSize: action.payload
            }
        case "CHANGE_CURRENT_PAGE_TEST_SUITE":
            return {
                ...state,
                currentPage: action.payload
            }
        default:
            return state
    }
}